// extracted by mini-css-extract-plugin
module.exports = {"main":"main___VF3hx","body":"body___3dj27"};